import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';

import { TitleWMutedRow } from '../../../sitel/demon/ui/atoms';
import { FieldValidationErrorMsg, HelpText, ILabelCheck } from '../../../sitel/demon/ui/atoms/form';

import { getOauthLink } from "../../../services/authCentral";

import schema from "./formSchema";
import useFormSubmit from "./useFormSubmit";
import { useOutletContext } from "react-router-dom";
import useOriginApp from "../../../services/useOriginApp";
import SubmitButton from "../../../sitel/demon/ui/atoms/buttons/SubmitButton";


/**
 * Entry point for a new Medstar employee account creation
 * 
 **/
export default function Step1ConfirmPage() {
    const { register, handleSubmit, formState: { errors, isSubmitting, isSubmitSuccessful } } = useForm({ resolver: yupResolver(schema()) });
    const onSubmit = useFormSubmit();
    const { language } = useOutletContext();
    const {path:originAppPath} = useOriginApp()
    
    return (
        <>
            <TitleWMutedRow muted={language.mutedTitle}>{language.title}</TitleWMutedRow>
            <p>Before creating your account, please confirm the following:</p>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group form-check mb-3">
                    <input type="checkbox" className="form-check-input" id="c1" {...register("c1")} />
                    <ILabelCheck iid="c1">I do not have a MedStar Health network ID</ILabelCheck>
                    <HelpText>For example: JXT111</HelpText>
                    <FieldValidationErrorMsg field="c1" errors={errors} />
                </div>

                <div className="form-group form-check mb-3">
                    <input type="checkbox" className="form-check-input" id="c2" {...register("c2")} />
                    <ILabelCheck iid="c2">I do not have a MedStar Health employee ID</ILabelCheck>
                    <HelpText>For example: 169145-0 or 169145</HelpText>
                    <FieldValidationErrorMsg field="c2" errors={errors} />
                </div>

                <div className="form-group form-check mb-3">
                    <input type="checkbox" className="form-check-input" id="c3" {...register("c3")} />
                    <ILabelCheck iid="c3">I do not have a MedStar Health email</ILabelCheck>
                    <HelpText>
                        This includes:<br />
                        &nbsp;&nbsp;@medstar.net<br />
                        &nbsp;&nbsp;@gunet.georgetown.edu<br />
                        &nbsp;&nbsp;@medstarmontgomery.org</HelpText>
                    <FieldValidationErrorMsg field="c3" errors={errors} />
                </div>

                <div className="form-group form-check mb-3">
                    <input type="checkbox" className="form-check-input" onClick={()=>window.location.href=getOauthLink(originAppPath)} />
                    <ILabelCheck iid="c4">I have one of these items</ILabelCheck>
                </div>

                <div className="form-row align-items-center">
                    <div className="col-auto my-3">
                        <SubmitButton isSubmitting={isSubmitting} isSubmitSuccessful={isSubmitSuccessful} className="btn-medstar-primary"/>
                    </div>
                </div>
            </form>
        </>
    )
}
